import { useCallback, useMemo } from 'react';
import * as Yup from 'yup';

export const useCompanyFoundedYearFilter = ({ setFilters }) => {
  const formSchema = useMemo(
    () =>
      Yup.object().shape({
        foundedYear: Yup.object().nullable(),
        foundedYearIncluded: Yup.object().nullable(),
      }),
    [],
  );

  const onSubmit = useCallback(
    (values) => {
      const rangeValues = values.foundedYear;
      const includedValue = values.foundedYearIncluded;
      const filterValue = rangeValues
        ? {
            founded_year_gteq: rangeValues.min,
            founded_year_lteq: rangeValues.max,
          }
        : null;

      setFilters({ foundedYear: filterValue, foundedYearIncluded: includedValue });
    },
    [setFilters],
  );

  return {
    formSchema,
    onSubmit,
  };
};
